import { z } from 'zod';

export const $CandidateResumeEditSchema = z.object({
  activitySphereIds: z.array(z.string()),
  desiredJob: z.string(),
  skillIds: z.array(z.string()),
  experience: z.string(),
  salary: z.string(),
  currencyId: z.string(),
  paymentPeriodId: z.string(),
  scheduleWorkIds: z.array(z.string()),
  employmentTypeIds: z.array(z.string()),
});
